/**
 * Detect if we're running in react-snap's headless browser.
 * react-snap sets the user agent to 'ReactSnap'.
 */
export const isPrerendering = () => {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
};
